export default {"src":"/_next/static/media/Search.bc612298.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};